module.exports = __webpack_public_path__ + "img/HealthHelp_Serea.97e2189a.svg";